export const GLOBAL_COUNTRY = 'Global';
export const STATUS_OK: number = 200;
export const STATUS_REDIRECT: number = 300;
export const ALL = 'all';
export const GLOBAL_LANGUAGE = 'English';
export const MAX_CART_QUANTITY = 999;
export const STATISTICS_REPORT_MAX_QUANTITY = 1;
export const STANDARDS_IDENTIFIER = 'ECOMM';
export const ICP_IDENTIFIER = 'ICP';
export const TRAINING_IDENTIFIER = 'LMS';
export const TRAINING_IDENTIFIER_COVEO = 'TrainingCourses';
export const GROUP_PAYMENT_IDENTIFIER = 'GroupPayment';
export const VERIFONE_PAYMENT_IDENTIFIER = 'VerifonePayment';
export const DIGITAL_DELIVERY = 'Digital Delivery';
export const PRINT_DELIVERY = 'Print Delivery';
export const DIGITAL_PRINT_DELIVERY = 'Digital and Print Delivery';
export const NO_DIGITAL_DELIVERY = 'No Digital Delivery';
export const STANDARDS_DIGITAL_DELIVERY = 'Standards';
export const PURCHASE_ORDER = 'PurchaseOrder';
export const QuantityExceedsCapacity = 'QuantityExceedsAvailableCapacity';
export const HARD_COPY_APPLICATIONS = ['ICPPrintDom', 'ICPPrintIntl', 'ICPPrintMultiCert'];
export const ProfileBillingAddress = 'Profile';
export const TempBillingAddress = 'TempAddress';

export const LOB_TITLES: { [key: string]: string } = {
  [STANDARDS_IDENTIFIER]: 'STANDARDS',
  [ICP_IDENTIFIER]: 'ICP',
  [TRAINING_IDENTIFIER]: 'TRAINING',
};

export const LOB_DISPLAY_NAMES: { [key: string]: string } = {
  [STANDARDS_IDENTIFIER]: 'Standards',
  [ICP_IDENTIFIER]: 'ICP',
  [TRAINING_IDENTIFIER]: 'Training',
};

export const PAYMENT_TYPES: Record<string, string> = {
  CreditCard: 'Credit Card',
  WireTransfer: 'Wire Transfer',
  Check: 'Check',
  ACH: 'ACH',
  GroupPayment: 'Group Payment',
};

export const PAYMENT_TYPES_ORDER = ['CreditCard', 'WireTransfer', 'Check', 'ACH'];

export const MONOGRAM_VERIFONE_INVOICE_CONFIG = {
  OLD: 'CNSUBM',
  NEW: 'INV44',
};

export function IsMonogramVerifoneOrder(invoiceNumber: string | null): boolean {
  if (invoiceNumber !== null) {
    return (
      invoiceNumber?.toLocaleUpperCase().startsWith(MONOGRAM_VERIFONE_INVOICE_CONFIG.NEW) ||
      invoiceNumber?.toLocaleUpperCase().endsWith(MONOGRAM_VERIFONE_INVOICE_CONFIG.OLD)
    );
  }
  return false;
}
